import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/images/desktop-pc.png'
import _imports_1 from '../../../assets/images/woman-desktop-success.svg'
import _imports_2 from '../assets/windows-blue.svg'
import _imports_3 from '../assets/windows-black.svg'
import _imports_4 from '../assets/mac-blue.svg'
import _imports_5 from '../assets/mac-black.svg'
import _imports_6 from '../assets/linux-blue.svg'
import _imports_7 from '../assets/linux-black.svg'


const _hoisted_1 = {
  id: "modal-plugin-download",
  class: "modal modal-md fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pb-3 border-bottom" }
const _hoisted_5 = { class: "modal-title plugin-modal-title" }
const _hoisted_6 = { class: "modal-body py-3" }
const _hoisted_7 = {
  key: 0,
  class: "desktop-img",
  alt: "Desktop",
  src: _imports_0
}
const _hoisted_8 = {
  key: 1,
  class: "desktop-img-success",
  alt: "Desktop",
  src: _imports_1
}
const _hoisted_9 = {
  key: 2,
  class: "fs-6 text-start mt-4"
}
const _hoisted_10 = {
  key: 3,
  class: "fs-6 text-start mt-4"
}
const _hoisted_11 = {
  key: 0,
  class: "fs-6 text-start mt-4"
}
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { class: "d-flex justify-content-center gap-5 mt-5 mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "blue-img",
  alt: "windows",
  src: _imports_2
}
const _hoisted_15 = {
  key: 1,
  class: "black-img",
  alt: "windows",
  src: _imports_3
}
const _hoisted_16 = {
  key: 0,
  class: "blue-img",
  alt: "mac",
  src: _imports_4
}
const _hoisted_17 = {
  key: 1,
  class: "black-img",
  alt: "windows",
  src: _imports_5
}
const _hoisted_18 = {
  key: 0,
  class: "blue-img",
  alt: "linux",
  src: _imports_6
}
const _hoisted_19 = {
  key: 1,
  class: "black-img",
  alt: "linux",
  src: _imports_7
}
const _hoisted_20 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_21 = { class: "modal-footer py-3" }
const _hoisted_22 = ["disabled"]

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import InputSelect from '../components/Atoms/InputSelect.vue'
  import usePluginDownloadConfirmationModal from '../composables/usePluginDownloadConfirmationModal'
  import { UserOperateSystem, getOs } from '@/utils/getOs'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import sendClarityEvent from '@/utils/sendClarityEvent'

  import { ref, onMounted, computed } from 'vue'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginDownload',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const autoIdentifiedOS = ref<UserOperateSystem>(UserOperateSystem.UNKNOWN)
  const selectedOS = ref<UserOperateSystem>(UserOperateSystem.UNKNOWN)
  const selectedVersion = ref<any>(undefined)
  const modalControlStore = useModalControl()
  const pluginStore = usePlugin()

  const {
    showPluginDownloadConfirmationModal,
    hidePluginDownloadConfirmationModal,
  } = usePluginDownloadConfirmationModal()

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-download', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  const issuedAt = computed(() => pluginStore.issuedAt?.trim()?.length > 0)

  function hide() {
    modal.value?.hide()
    selectedOS.value = UserOperateSystem.UNKNOWN
  }

  function selectOs(OS: UserOperateSystem) {
    selectedOS.value = OS
    selectedVersion.value = undefined
  }

  const linuxIsSelected = computed(() => {
    if (selectedOS.value === UserOperateSystem.LINUX) return true
    return false
  })

  const linuxOptions = [
    { label: 'bird-sign-plugin.appimage', value: 1 },
    { label: 'bird-sign-plugin', value: 2 },
  ] as any

  const macIsSelected = computed(() => {
    if (selectedOS.value === UserOperateSystem.MACOS) return true
    return false
  })

  const macOptions = [{ label: 'birdid-sign-plugin.dmg', value: 1 }] as any

  const windowsIsSelected = computed(() => {
    if (selectedOS.value === UserOperateSystem.WINDOWS) return true
    return false
  })

  const windowsOptions = [
    { label: 'windows-32', value: 1 },
    { label: 'windows-64', value: 2 },
  ] as any

  const versionOptions = computed(() => {
    if (selectedOS.value === UserOperateSystem.LINUX) return linuxOptions
    if (selectedOS.value === UserOperateSystem.MACOS) return macOptions
    if (selectedOS.value === UserOperateSystem.WINDOWS) return windowsOptions
    return []
  })

  const versionLinks = [
    {
      label: 'bird-sign-plugin.appimage',
      link: 'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Linux/Linux-64/BirdID-Sign-Plugin.AppImage',
    },
    {
      label: 'bird-sign-plugin',
      link: 'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Linux/Linux-64/birdid-sign-plugin',
    },
    {
      label: 'birdid-sign-plugin.dmg',
      link: 'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/MacOS/BirdID-Sign-Plugin.dmg',
    },
    {
      label: 'windows-32',
      link: 'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Windows/Windows-32/birdid-sign-plugin.exe',
    },
    {
      label: 'windows-64',
      link: 'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Windows/Windows-64/birdid-sign-plugin.exe',
    },
  ]

  function downloadPluginVersion() {
    sendClarityEvent('downloadPlugin')
    const link = versionLinks.find(
      (version) => version.label === selectedVersion.value.label,
    )?.link
    if (link) window.open(link, '_blank')
    hide()
    modalControlStore.show({
      modalId: 'pluginDownloadConfirmationModal',
      show: showPluginDownloadConfirmationModal,
      hide: hidePluginDownloadConfirmationModal,
    })
  }

  function show() {
    const osInfo = getOs()
    autoIdentifiedOS.value = osInfo.os
    selectedOS.value = osInfo.os
    selectedVersion.value = osInfo.arch

    selectedVersion.value = 1

    if (osInfo.os === UserOperateSystem.LINUX) {
      selectedVersion.value = linuxOptions[1]
    }

    if (osInfo.os === UserOperateSystem.WINDOWS && osInfo.arch === 64) {
      selectedVersion.value = windowsOptions[1]
    }

    if (osInfo.os === UserOperateSystem.MACOS) {
      selectedVersion.value = macOptions[0]
    }

    if (osInfo.arch === undefined) {
      selectedVersion.value = undefined
    }

    if (osInfo.os === UserOperateSystem.ANDROID) {
      selectedVersion.value = undefined
    }

    if (osInfo.os === UserOperateSystem.IOS) {
      selectedVersion.value = undefined
    }

    modal.value?.show()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(!issuedAt.value ? 'Solicitação Aprovada' : 'Certificado emitido') + "! ", 1),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: hide
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (
              !issuedAt.value && !(autoIdentifiedOS.value === _unref(UserOperateSystem).UNKNOWN)
            )
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true),
          (issuedAt.value && !(autoIdentifiedOS.value === _unref(UserOperateSystem).UNKNOWN))
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true),
          (!issuedAt.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _cache[7] || (_cache[7] = [
                _createTextVNode(" Sua solicitação foi "),
                _createElementVNode("strong", null, "aprovada!", -1),
                _createTextVNode(" Para prosseguir com a "),
                _createElementVNode("strong", null, "emissão do seu Certificado Digital", -1),
                _createTextVNode(" é necessário baixar o plugin, \""),
                _createElementVNode("strong", null, "BirdID-Sign-Plugin", -1),
                _createTextVNode("\" em seu computador. ")
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
                  _createElementVNode("strong", null, "Seu Certificado foi emitido com sucesso!")
                ], -1)),
                (issuedAt.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _cache[8] || (_cache[8] = [
                      _createTextVNode(" Para baixá-lo, é necessário ter o "),
                      _createElementVNode("strong", null, " plugin em execução ", -1),
                      _createTextVNode(" no seu computador. ")
                    ])))
                  : _createCommentVNode("", true)
              ])),
          (autoIdentifiedOS.value === _unref(UserOperateSystem).UNKNOWN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, " Escolha abaixo o Sistema Operacional abaixo: ", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "windows-container d-flex flex-column justify-content-center",
                    onClick: _cache[0] || (_cache[0] = () => selectOs(_unref(UserOperateSystem).WINDOWS)),
                    onKeydown: _cache[1] || (_cache[1] = () => selectOs(_unref(UserOperateSystem).WINDOWS))
                  }, [
                    (windowsIsSelected.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                      : (_openBlock(), _createElementBlock("img", _hoisted_15)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mt-2", { 'selected-label': windowsIsSelected.value }])
                    }, " Windows ", 2)
                  ], 32),
                  _createElementVNode("div", {
                    class: "mac-container d-flex flex-column justify-content-center",
                    onClick: _cache[2] || (_cache[2] = () => selectOs(_unref(UserOperateSystem).MACOS)),
                    onKeydown: _cache[3] || (_cache[3] = () => selectOs(_unref(UserOperateSystem).MACOS))
                  }, [
                    (macIsSelected.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                      : (_openBlock(), _createElementBlock("img", _hoisted_17)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mt-2", { 'selected-label': macIsSelected.value }])
                    }, " Mac ", 2)
                  ], 32),
                  _createElementVNode("div", {
                    class: "linux-container d-flex flex-column justify-content-center",
                    onClick: _cache[4] || (_cache[4] = () => selectOs(_unref(UserOperateSystem).LINUX)),
                    onKeydown: _cache[5] || (_cache[5] = () => selectOs(_unref(UserOperateSystem).LINUX))
                  }, [
                    (linuxIsSelected.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                      : (_openBlock(), _createElementBlock("img", _hoisted_19)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mt-2", { 'selected-label': linuxIsSelected.value }])
                    }, " Linux ", 2)
                  ], 32)
                ]),
                (selectedOS.value != _unref(UserOperateSystem).UNKNOWN)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-start fs-6" }, "Selecione a versão", -1)),
                      _createVNode(InputSelect, {
                        modelValue: selectedVersion.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedVersion).value = $event)),
                        options: versionOptions.value,
                        icon: "download",
                        placeholder: "Selecione a versão do Sistema Operacional"
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", [
              selectedVersion.value === undefined ? 'btn-secondary' : 'btn-primary',
            ]]),
            type: "button",
            disabled: selectedVersion.value === undefined,
            onClick: downloadPluginVersion
          }, [
            _createVNode(IconComponent, {
              class: "me-2",
              name: "download"
            }),
            _cache[12] || (_cache[12] = _createTextVNode(" Baixar Plugin "))
          ], 10, _hoisted_22)
        ])
      ])
    ])
  ]))
}
}

})